import React, { useEffect, useState } from "react";
import ExerciseBtn from "./ExerciseBtn";
import LoadableComponent from "../../shared/Loading/LoadableComponent";
import { Box } from "@material-ui/core";
import useWithDispatch from "../../utils/hook/withDispatchHook";
import { Exercise } from "../../models/Exercise";
import { selectExerciseBySeat } from "../../store/basket/basketActions";
import { useHistory } from "react-router";
import { SEAT_SALE } from "../../Routing/routes";
import getId from "../../utils/getId";

const styleContainer = { paddingLeft: "2%", paddingRight: "2%", marginBottom: 50 };

interface IProps {
  loading: boolean;
  date: Date;
  exerciseList: Exercise[];
  setDate: (value: Date) => void;
  activeStep: number;
  setActiveStep: (value: number) => void;
  getTicket: () => void;
}

const SeatSaleView: React.FC<IProps> = ({
  loading,
  exerciseList,
  setActiveStep,
  activeStep,
  getTicket,
}: IProps) => {
  const witchDispatch = useWithDispatch();
  const [isSelectExercise, setIsSelectExercise] = useState(false);
  const history = useHistory();

  const handleSelectExercise = (exercise: Exercise) => {
    witchDispatch(selectExerciseBySeat)(exercise);
    setIsSelectExercise(true);
  };

  useEffect(() => {
    if (isSelectExercise) {
      setActiveStep(activeStep + 1);
      getTicket();
      setIsSelectExercise(false);
    }
  }, [isSelectExercise]);

  return (
    <React.Fragment>
      <LoadableComponent loading={loading}>
        <Box style={styleContainer}>

          <div className="ticket">
            {exerciseList.map((item, index) => (
              <ExerciseBtn
                key={index}
                exercise={item}
                onBtnClick={(exercise: Exercise) => {
                  handleSelectExercise(exercise);
                  history.push(`${SEAT_SALE}?exerciseIds=${getId(exercise)}`);
                }}
              />
            ))}
          </div>
        </Box>
      </LoadableComponent>
    </React.Fragment>
  );
};

export default SeatSaleView;
